var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"type":"error","value":true,"transition":"v-scroll-y","dismissible":""}},[_vm._v("\n    "+_vm._s(_vm.message)+"  \n")])}
var staticRenderFns = []

export { render, staticRenderFns }